import { h } from 'preact'; /** @jsx h */
import { useState } from 'preact/hooks';
import { Link } from 'preact-router';
import './MenuDropdown.scss';

export const MenuDropdown = (props) => {
    const { buttons } = props;
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`wrapper-DD ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} className="toggle-DD">
                <div className="icon-DD">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </button>
            {isOpen && (
                <ul className="menu-DD">
                    {buttons.map((button) => (
                        <li className="item-DD">
                            <Link className="link-DD" href={button.link}>
                                {button.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
